const Footer = ({ testimonials }) => {
  return (
    <div className="w-full py-8">
      <div className="w-full flex justify-center items-center pb-4 text-white font-semibold text-3xl sm:text-5xl border-b-2 border-gray-700">
        TESTIMONIALS
      </div>
      <div className="w-full py-8 flex flex-wrap">
        {testimonials.map((testimonial, index) => {
          return (
            <img
              src={testimonial}
              alt={`Testimonial ${index}`}
              key={index}
              className="w-full px-2 mb-4 md:w-1/2 lg:w-1/3 xl:w-1/4 sm:h-72 h-96 bg-cover cursor-pointer"
            />
          );
        })}
      </div>
      <div className="flex justify-center items-center w-full">
        <a
          href="https://bit.ly/3PvH1Lj"
          className="w-[90vw] md:w-[50vw] text-center py-4 text-xl border-2 border-rose-600 text-white hover:bg-zinc-800 active:bg-zinc-900 outline-none"
        >
          Enroll Now
        </a>
      </div>
    </div>
  );
};

export default Footer;
